import BlackBadge from './Black_Badge.svg';
import BlackMonochromeBadge from './Black_Badge_Monochrome.svg';
import WhiteBadge from './White_Badge.svg';
import WhiteMonochromeBadge from './White_Badge_Monochrome.svg';

interface BadgeProps {
    Badge: React.ElementType;
    term: number;
}

export enum Badge {
    BlackMonochrome = 'black-monochrome',
    Black = 'black',
    WhiteMonochrome = 'white-monochrome',
    White = 'white',
}

export const badges: Record<Badge, BadgeProps> = {
    [Badge.Black]: { Badge: BlackBadge, term: 1 },
    [Badge.White]: { Badge: WhiteBadge, term: 2 },
    [Badge.BlackMonochrome]: { Badge: BlackMonochromeBadge, term: 3 },
    [Badge.WhiteMonochrome]: { Badge: WhiteMonochromeBadge, term: 4 },
};
